/* eslint-disable prettier/prettier */
import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'


// An AI tool run takes 3 to 30 seconds and each tool page shows its own
// pending state (a spinner on its disabled run button, a skeleton where the
// answer will be), so it does not cover the screen (background), and its
// answer is shown on the page, not toasted.
const toolRun = { silentToast: true, background: true }

const AIService = {
    getStatus: () => axiosInstance.get(endpoints.aiSettingsStatus),

    // provider: 'anthropic' (Claude) or 'openai'. The API checks the key with
    // the provider before saving it.
    saveKey: (apiKey, provider) =>
        axiosInstance.post(endpoints.aiSettingsKey, {
            api_key: apiKey,
            provider,
        }),

    deleteKey: (provider) =>
        axiosInstance.delete(endpoints.aiSettingsKey, { params: { provider } }),

    // Switches every AI tool to `provider`; answers the new status.
    setProvider: (provider) =>
        axiosInstance.put(endpoints.aiSettingsProvider, { provider }),

    // Sets the model the AI tools use on `provider`; answers the new status.
    setModel: (provider, model) =>
        axiosInstance.put(endpoints.aiSettingsModel, { provider, model }),

    // config: extra request options, e.g. silentErrorToast where the page shows the error.
    generateTemplate: (payload, config = {}) =>
        axiosInstance.post(
            endpoints.aiGenerateTemplate,
            payload,
            { ...toolRun, ...config }
        ),

    translateTemplate: (payload) =>
        axiosInstance.post(
            endpoints.aiTranslateTemplate,
            payload,
            toolRun
        ),

    validateCSV: (payload) =>
        axiosInstance.post(endpoints.aiValidateCSV, payload, toolRun),

    bulkPreview: (payload) =>
        axiosInstance.post(endpoints.aiBulkPreview, payload, toolRun),

    campaignBrief: (payload) =>
        axiosInstance.post(
            endpoints.aiCampaignBrief,
            payload,
            toolRun
        ),

    performanceInsights: (payload) =>
        axiosInstance.post(
            endpoints.aiPerformanceInsights,
            payload,
            toolRun
        ),

    templateVariants: (payload) =>
        axiosInstance.post(
            endpoints.aiTemplateVariants,
            payload,
            toolRun
        ),

    unsubscribeRisk: (payload) =>
        axiosInstance.post(
            endpoints.aiUnsubscribeRisk,
            payload,
            toolRun
        ),

    audienceOverlap: (payload) =>
        axiosInstance.post(
            endpoints.aiAudienceOverlap,
            payload,
            toolRun
        ),

    crmLookup: (payload) =>
        axiosInstance.post(endpoints.aiCRMLookup, payload, toolRun),

    commsFinder: (payload) =>
        axiosInstance.post(endpoints.aiCommsFinder, payload, toolRun),

}

export default AIService
